import { render, staticRenderFns } from "./CartaCorrecaoNotaFiscal.vue?vue&type=template&id=0d34951c&scoped=true&"
import script from "./CartaCorrecaoNotaFiscal.vue?vue&type=script&lang=js&"
export * from "./CartaCorrecaoNotaFiscal.vue?vue&type=script&lang=js&"
import style0 from "./CartaCorrecaoNotaFiscal.vue?vue&type=style&index=0&id=0d34951c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d34951c",
  null
  
)

export default component.exports